// 首城开 普埃布拉 | Puebla | 52210400 | MX
// CR 圣何塞
const data = {
  MX: {
    poiId: '2882303761546018022',
    displayName: 'Universidad Popular Autónoma Del Estado de Puebla',
    address: 'Puebla, Puebla, México',
    lat: 19.0486,
    lng: -98.21656,
    srcTag: 'newes#ac_mining_end',
    poiSrcTag: 'manual_sug',
    coordinateType: 'wgs84',
    cityId: 52210400,
    city: 'Puebla',
    searchId: '0a9ddc9363494ac594fcb32b0c589e02',
    addressAll:
      'Universidad Popular Autónoma Del Estado de Puebla, Puebla, Puebla, México',
    addressAllDisplay: 'Puebla, Puebla, México',
    countryCode: 'MX',
    countryId: 52,
    distStr: '99+km',
    poiType: 'Higher Education',
    countyId: 52210416,
    countyGroupId: 522104000001,
  },
  CR: {
    poiId: 'ChIJxRUNxULjoI8RgrgRn2pqdOY',
    addressAllDisplay: 'San José, Costa Rica',
    city: 'San José',
    cityId: 506070100,
    countryCode: 'CR',
    countryId: 506,
    lat: 9.9280694,
    lng: -84.0907246,
    displayName: '圣何塞',
    address: 'San José, Costa Rica',
    addressAll: '圣何塞, San José, Costa Rica',
    coordinateType: 'wgs84',
    poiSrcTag: 'manual_sug',
    distStr: '167m',
    poiType: 'locality;political;geocode',
    countyId: 506070144,
    countyGroupId: 5060701000001,
  },
};

class DefaultPoi {
  constructor(option) {
    const { data, defaultRegion = 'MX' } = option;
    (this.data = data), (this.defaultRegion = defaultRegion);
  }
  getPoi(region) {
    return this.data[region] || this.data[this.defaultRegion];
  }
}

const defaultPoi = new DefaultPoi({
  data,
  defaultRegion: 'MX',
});

export default defaultPoi;
